import { useQuery } from '@tanstack/vue-query'
import { TWO_MINUTES_MS } from '@shared/utils'
import { bankAccountKeys } from '../bankAccountQueryKeys'
import { getBankAccounts } from '../bankAccountEndpoints'
import { parseBankAccountListToView } from '../bankAccountParser'

export function useBankAccountsQuery() {
  return useQuery({
    queryKey: bankAccountKeys.list(),
    queryFn: () => getBankAccounts().then(parseBankAccountListToView),
    staleTime: TWO_MINUTES_MS,
  })
}
